import { IAppState } from "../state/app.state";
import { createSelector } from "@ngrx/store";
import { ISignUpState } from "../state/signup.state";

const selectSignUpState = (state: IAppState) => state.signUp;

export const selectUserDataResponse = createSelector(selectSignUpState, (state: ISignUpState) => state.userData);
